const STORAGE_KEY = "waitercall.authRedirect";

export const AUTH_REDIRECT_REASONS = {
  sessionExpired: "session_expired",
  accessBlocked: "access_blocked",
};

const getWindowSessionStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const storeAuthRedirectContext = (context) => {
  const storage = getWindowSessionStorage();
  if (!storage) {
    return;
  }

  try {
    storage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        reason: context?.reason || AUTH_REDIRECT_REASONS.sessionExpired,
        message: String(context?.message || "").trim() || null,
        at: Date.now(),
      }),
    );
  } catch {
    try {
      storage.removeItem(STORAGE_KEY);
    } catch {
      // Ignore sessionStorage cleanup failures. Redirect context is best-effort.
    }
  }
};

export const consumeAuthRedirectContext = () => {
  const storage = getWindowSessionStorage();
  if (!storage) {
    return null;
  }

  let raw = null;

  try {
    raw = storage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }

  if (!raw) {
    return null;
  }

  try {
    storage.removeItem(STORAGE_KEY);
  } catch {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    return {
      reason: parsed?.reason || AUTH_REDIRECT_REASONS.sessionExpired,
      message:
        typeof parsed?.message === "string" && parsed.message.trim().length
          ? parsed.message.trim()
          : null,
    };
  } catch {
    return null;
  }
};
